import 'whatwg-fetch';
import config from '../../config/config';

const { API_BONUSES_URL, API_BONUSES_APPLY_POINTS_URL } = config;

export const bonusesApi = {
    /**
     * GET /wp-json/app/v1/bonuses
     * Ответ: { bonus_level, wallet_money, wallet_points_active,
     *          wallet_points_pending, wallet_points_next_activation_date, available_to_spend }
     */
    fetchBonuses: async (token) => {
        const response = await fetch(API_BONUSES_URL, {
            headers: { Authorization: 'Bearer ' + token },
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || `HTTP ${response.status}`);
        }

        return result;
    },

    /**
     * POST /wp-json/app/v1/bonuses/apply-points
     * Body: { cart_total } — сумма корзины без доставки.
     * Ответ содержит купон, который передаётся в coupon при создании заказа.
     */
    applyPoints: async (cartTotal, token) => {
        const response = await fetch(API_BONUSES_APPLY_POINTS_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
            },
            body: JSON.stringify({ cart_total: cartTotal }),
        });

        const result = await response.json();

        const data = result.data || result;
        const coupon = data.coupon || data.coupon_code || null;

        if (response.ok && coupon) {
            return {
                success: true,
                coupon,
                amount: Number(data.amount ?? data.discount ?? data.points_spent ?? 0),
            };
        }

        return {
            success: false,
            message: result.message || 'Не удалось списать баллы',
        };
    },
};
